<i18n>
{
"en": {
  "ROUTETRIP": "Route Trip:",
  "STOP": "Stop",
  "TO": "To",
  "SCHOOL": "School",
  "HOME": "Home",
  "ESTIMATEDARRIVALTIME": "Estimated arrival time:",
  "MIN": "min",
  "CHECKEDINAT": "Checked in at",
  "CHECKEDOUTAT": "Checked out at",
  "ABSENTAT": "Absent at",
  "ABSENT": "Absent",
  "NOSTUDENTSADDEDTOTHISSTOP": "No students added to this stop",
  "ROUTE": "Route",
  "SUPERVISOR": "Supervisor",
  "DRIVER": "Driver",
  "LOADING": "Loading...",
  "BASEBETWEEN": "Base between 2 and 36",
  "STARTEDAT": "Started at",
  "CLOSEDAT": "Closed at",
  "EXPECTEDTOSTART": "Expected To Start..",
  "FUELCOST": "Fuel Cost",
  "TOTALCOST": "Total Cost",
  "IDLECOST": "Idle Cost",
  "AED": "AED",
  "FACTORS": "Factors",
  "COST": "Cost",
  "TIME": "Time",
  "FORMULA": "Formula",
  "RESULT": "Result",
  "INSURANCE": "Insurance",
  "VECHICLEPAYMENTS": "Vechicle Payments",
  "REGISTRATION": "Registration",
  "INSPECTION": "Inspection",
  "VEHICLEPERMIT": "Vehicle Permit",
  "VEHICLEDEPRECIATION": "Vehicle Depreciation",
  "FUELCONSUMPTION": "Fuel Consumption",
  "OILCHANGE": "Oil Change",
  "IDLING": "Idling",
  "TIRES": "Tires",
  "WEARTEAR": "Wear / Tear",
  "TOTALCOST": "Total Cost",
  "MAP": "Map",
  "EXPENDITURE": "Expense",
  "TRIPDISTANCE": "Trip Distance:",
  "TRIPIDLING": "Trip Idling:",
  "COMPLETEDTRIPS": "Completed Trips:",
  "TRIP": "trip | trips",
  "GUARDIAN": "Guardian",
  "NAANI": "Supervisor" ,
  "REPORTEDBY": "Reported-By"
},
"ar": {
  "ROUTETRIP": ":خط السير",
  "STOP": "توقف",
  "TO": "إلى",
  "SCHOOL": "المدرسة",
  "HOME": "البيت",
  "ESTIMATEDARRIVALTIME": "الوقت المتوقع للوصول",
  "MIN": "دقيقة",
  "CHECKEDINAT": "تسجيل الوصول في",
  "CHECKEDOUTAT": "تسجيل الخروج في",
  "ABSENTAT": "متغيب في",
  "ABSENT": "متغيب",
  "NOSTUDENTSADDEDTOTHISSTOP": "لم يتم اضافة أي طالب لهذا التوقف",
  "ROUTE": "خط السير",
  "SUPERVISOR": "المشرفة",
  "DRIVER": "سائق",
  "LOADING": "جار التحميل...",
  "BASEBETWEEN": "Base between 2 and 36",
  "STARTEDAT": "بدأت في",
  "CLOSEDAT": "مغلق في",
  "NOTCLOSINGYET": "لم يتم الإغلاق بعد",
  "EXPECTEDTOSTART": "...من المتوقع البدء ",
  "FUELCOST": "تكلفة السفر هو",
  "TOTALCOST": "تكلفة صيانة المركبات هي",
  "IDLECOST": "تكلفة الوقت الضائع",
  "AED": "درهم",
  "FACTORS": "عوامل",
  "COST": "التكلفة",
  "TIME": "الزمن",
  "FORMULA": "صيغة",
  "RESULT": "النتيجة",
  "INSURANCE": "التامين",
  "VECHICLEPAYMENTS": "تسديدات المركبة",
  "REGISTRATION": "التسجيل",
  "INSPECTION": "التفتيش",
  "VEHICLEPERMIT": "ترخيص المركبات",
  "VEHICLEDEPRECIATION": "نقص قيمة المركبات",
  "FUELCONSUMPTION": "استهلاك الوقود",
  "OILCHANGE": "تغيير الزيت",
  "IDLING": "فتور المحرك",
  "TIRES": "الإطارات",
  "WEARTEAR": "استهلاك القيمة بالاستعمال",
  "TOTALCOST": "التكلفة الإجمالية",
  "MAP": "خريطة",
  "EXPENDITURE": "المصروفات",
  "TRIPDISTANCE": ":مسافة الرحلة",
  "TRIPIDLING": " فترات فتور المحرك",
  "COMPLETEDTRIPS": ":رحلات المكتملة",
  "TRIP": "رحلة | الرحلات",
  "GUARDIAN": "ولي الامر",
  "NAANI": "مشرفة",
  "REPORTEDBY": "تم عمل تقرير بواسطة"
}
}
</i18n>
<template>
  <div class="form" id="tripMng">
    <el-card  class="card-border" ref="card" :body-style="{ padding: 0 }">
      <div slot="header" class="clearfix">
        <el-row style="line-height: 36px;">
          <span class="el-col el-col-8">{{$t('ROUTETRIP')}} <b>{{tripDate(trip.Db_Date)}}</b> </span>
            </el-row>            
          </div>
      <el-col :span="8">  
        <el-card style="border:0"  v-loading="loading_stops" :element-loading-text="$t('LOADING')"  class="box-card" :body-style="{ padding: 0, height: cardHeight + 'px'  }">    
            <VuePerfectScrollbar  ref="Scrollbar" class="scrollbar"  v-bind:style="{ height: tabHeight + 'px' }">
            <el-row>
            <el-steps :space="200" direction="vertical" :active="1">
                <div class="el-step is-vertical" style="margin-right: 0px; min-height:50px;" :key="key" v-for="(stop, key) in stops">
                  <div class="el-step__head is-finish is-text">
                    <div class="el-step__line is-vertical" style="margin-right: 0px;">
                    <i class="el-step__line-inner" style="transition-delay: 0ms; height: 100%;"></i></div>
                    <span class="el-step__icon">
                      <div v-text="key"  v-if="key !== 0"></div>
                      <div  v-if="key === 0"><i class="fa fa-bus"></i> </div>
                    </span>
                  </div>
                  <div class="el-step__main">
                    <div class="el-step__title is-finish">
                      <span v-text="key !== 0 ? $t('STOP') : $t('TO') + ' ' + (trip.Direction==1 ? $t('SCHOOL') : $t('HOME'))"></span> <span v-text="key" v-if="key !== 0"></span>
                      <div v-if="key == 0" class="pull-right">
                        <el-row v-if="trip.Db_Date != null"><span style="font-weight: 400;" v-text="$t('STARTEDAT') + ':'"></span> {{unixConverter(trip.timestamp)}}</el-row>
                        <el-row v-if="trip.IsClosed == 1"><span style="font-weight: 400;" v-text="$t('CLOSEDAT') + ':'"></span> {{unixConverter(trip.UpdatedAt)}}</el-row>
                      </div>
                      <el-card class="box-card students"  :body-style="{ padding: '0px' }"  v-if="key !== 0">
                        <div slot="header" class="clearfix">
                        <small>{{$t('ESTIMATEDARRIVALTIME')}} <span v-text="stop.DeltaT"></span> {{$t('MIN')}}</small>
                        </div>
                        <el-row  class="list" :key="index" v-for="(student, index) in stop.student" v-if="key !== 0" :style="{'background-color': [(student.IsAbsent) ? '#CCCCCC' : 'unset']}">
                          <span ><i class="fa fa-wifi fa-rotate-270 fa-2x" v-bind:class="tagIcon(student)"></i></span>
                          <img :src="getAsset(student.ImagePath, 'student')"  class="img-circle" style="width: 50px;">
                          {{_FullName({NameEN: student.FullName_EN, NameAR: student.FullName_AR})}}             
                          <el-button-group class="turn">
                          <el-tooltip  v-if="student.CheckIn" :content="$t('CHECKEDINAT') + ' '+ tripTime(student.CheckIn)" placement="top">
                            <el-button type="success" icon="arrow-up" size="mini">{{tripTime(student.CheckIn)}}</el-button>
                          </el-tooltip>
                          <el-tooltip  v-if="student.IsMissing" :content="$t('ABSENTAT') + ' '+ tripTime(student.IsMissing)" placement="top">
                            <el-button type="danger"  icon="warning"  size="mini">{{tripTime(student.IsMissing)}}</el-button>
                          </el-tooltip>  
                          <el-tooltip v-if="student.CheckOut"  :content="$t('CHECKEDOUTAT') + ' '+ tripTime(student.CheckOut)" placement="top">
                            <el-button type="warning"  icon="arrow-down"  size="mini">{{tripTime(student.CheckOut)}}</el-button>
                          </el-tooltip>

                          <el-tooltip v-if="student.IsAbsent"  :content="$t('REPORTEDBY') + ' ' + student.IsAbsent.ReportedBy" placement="top">
                            <el-button type="danger"  icon="warning"  size="mini">{{$t('ABSENT')}}</el-button>
                          </el-tooltip>
                          </el-button-group>                     
                        </el-row>
                      <el-row v-if=" stop.student.length===0 && key!==0" style="padding:10px; background-color: rgb(209, 219, 229); color:#4b4b4b">
                        <el-col  align="center"><b>{{$t('NOSTUDENTSADDEDTOTHISSTOP')}}</b></el-col>
                      </el-row>
                      <el-row class="only-top-border"></el-row>
                    </el-card>
                  
                  </div>

                </div>
</div>
              </el-steps>
            </el-row>
      </VuePerfectScrollbar>
</el-card>
      </el-col>


      <el-col :span="16"  v-loading="loading" :element-loading-text="$t('LOADING')">
        <el-tabs type="border-card" class="formTab" v-bind:style="{ height: cardHeight + 'px' }" @tab-click="getExpense()">
          <el-tab-pane>
            <span slot="label"><i class="fa fa-map"></i> {{$t('Map')}}</span>
            <el-card  style="border-top:0; border-bottom:0" clasExpenditures="bordred-card" :body-style="{ padding: 0, height: cardHeight + 'px' }">
    
                <el-row  :gutter="20" ref="staff" style="padding:10px">
                  <el-col :span="8" class="border1">
                  <i class="fa fa-road fa-3x"></i>
                  <b>{{$t('ROUTE')}}</b><br/>
                    <el-tag   v-bind:style="'background-color:' + route.RouteColor"># {{trip.TourName}}</el-tag>  
                </el-col>
                  <el-col :span="8"  class="border2">
                    <img :src="getAsset(monitor.ImagePath, 'supervisor')"  class="img-circle" style="width: 50px;">
                    <b>{{$t('SUPERVISOR')}}</b><br/>
                    {{_FullName({NameEN: monitor.FullName_EN, NameAR: monitor.FullName_AR})}}
                </el-col>
                  <el-col :span="8">
                    <img :src="getAsset(driver.ImagePath, 'driver')"  class="img-circle" style="width: 50px;">
                    <b>{{$t('DRIVER')}}</b><br/>
                    {{_FullName({NameEN: driver.FullName_EN, NameAR: driver.FullName_AR})}}
                </el-col>
                </el-row>
                <el-row id="trip-gmap-live"  v-bind:style="{ height: mapHeight + 'px' }"  style="position:relative; border-top:1px solid rgb(209, 219, 229);"></el-row>
                <el-row v-show ="showCost(trip)" :gutter="20" style="padding:10px" ref="cost">
                  <el-col :span="8" class="border1">
                    <i class="fa fa-money fa-3x"></i>
                    <b>{{$t('FUELCOST')}}</b><br/>
                    <el-tag>{{trip.TravelCost + ' ' + $t('AED')}} </el-tag>
                    </el-col>
                  <el-col :span="8" class="border1">
                    <i class="fa fa-money fa-3x"></i>
                    <b>{{$t('IDLECOST')}}</b><br/>
                    <el-tag type="danger">{{trip.IdleCost + ' ' + $t('AED')}} </el-tag>
                    </el-col>
                  <el-col :span="8" class="border1">
                    <i class="fa fa-money fa-3x"></i>
                    <b>{{$t('TOTALCOST')}}</b><br/>
                    <el-tag>{{trip.TotalCost + ' ' + $t('AED')}} </el-tag>
                    </el-col>
                </el-row>        
            </el-card>
          </el-tab-pane>
          <el-tab-pane v-if="showCost(trip)">
            <span slot="label"><i class="fa fa-money"></i> {{$t('EXPENDITURE')}}</span>
            <el-row style="padding:20px; padding-bottom:0;font-size: 14px;">
              <span class="el-col el-col-6">{{$t('TRIPDISTANCE')}} <b>{{distance + ' ' + 'km'}}</b> </span>
              <span class="el-col el-col-6">{{$t('TRIPIDLING')}} <b>{{idlingTime + ' ' + 'mins'}}</b> </span>
              <span class="el-col el-col-6">{{$t('COMPLETEDTRIPS')}} <b>{{expense.doneTrips}}</b> </span>
            </el-row>
           <el-row class="tab-table-margin" style="margin-top:20px">
            <el-table
              :data="listExpenses"
              highlight-current-row
              :height="620"
              stripe
              show-summary
              :summary-method="getSummaries"
              style="width: 100%">
              <el-table-column
                :label="$t('FACTORS')" min-width="100">
                <template slot-scope="scope">
                  {{$t(scope.row.label)}}
                </template>
              </el-table-column>
              <el-table-column
                :label="$t('COST')" prop="cost">
                <template slot-scope="scope">
                  {{$t(scope.row.cost)}}
                </template>
              </el-table-column>
              <el-table-column
                :label="$t('TIME')">
                <template slot-scope="scope">
                  <i :class="[scope.row.time ? 'el-icon-time' : '']"></i>
                  {{$t(scope.row.time)}}
                </template>
              </el-table-column>
              <el-table-column
                :label="$t('FORMULA')" min-width="200">
                <template slot-scope="scope">
                  <el-tag>{{$t(scope.row.calc)}}</el-tag>
                </template>
              </el-table-column>
              <el-table-column
                :label="$t('RESULT')" prop="result">
                <template slot-scope="scope">
                  {{$t(scope.row.result)}}
                </template>
              </el-table-column>               
            </el-table>
          </el-row>            
          </el-tab-pane>
        </el-tabs>
      </el-col>
 
     </el-card>

  </div>
</template>
<script>
  import qs from 'qs'
  import { EventBus } from '../../event-bus.js'
  import VuePerfectScrollbar from 'vue-perfect-scrollbar'
  import _ from 'lodash'
  export default {
    components: {VuePerfectScrollbar},
    data () {
      return {
        trips: {},
        trip: {},
        route: {},
        bus: {},
        driver: {},
        monitor: {},
        expense: {},
        stops: [],
        loading: true,
        loading_stops: true,
        cardHeight: 0,
        tabHeight: 0,
        mapHeight: 0,
        distance: 0,
        idlingTime: 0,
        center: {lat: 0, lng: 0},
        marker: {lat: 0, lng: 0, icon: {url: require('../../assets/img/map/location-marker.png')}},
        maps: null,
        map: null,
        markers: [],
        MarkerWithLabel: null,
        pulse: null,
        path: null
      }
    },
    mounted () {
      this.switchLanguage()
      let userData = JSON.parse(localStorage.getItem('userData'))
      this.center = {lat: userData.school_location.Lat, lng: userData.school_location.Lng}
      this.cardHeight = window.innerHeight - this.$refs.card.$el.children[0].offsetHeight - 53
      this.mapHeight = this.cardHeight - this.$refs.staff.$el.offsetHeight - 105
      this.tabHeight = this.cardHeight
      let self = this
      this.$google.then(function (Maps) {
        self.maps = Maps
        self.map = new Maps.Map(document.getElementById('trip-gmap-live'), {
          center: new Maps.LatLng(self.center),
          zoom: 14
        })
        self.MarkerWithLabel = require('markerwithlabel')(Maps)
      })
      this.getTrips()
      EventBus.$on('trip', trip => {
        let TripID = trip.TripID
        if (this.trip.TripID === TripID && trip.IsClosed === 1) {
          this.trip.IsClosed = trip.IsClosed
          this.trip.UpdatedAt = trip.UpdatedAt
          if (trip.TotalCost !== undefined) {
            this.trip.TotalCost = trip.TotalCost
            this.trip.TravelCost = trip.TravelCost
            this.trip.TotalCost = trip.TotalCost
            this.trip.IdleCost = trip.IdleCost
          }
        }
      })
    },
    computed: {
      listExpenses () {
        let factors = [{key: 'Driver', label: this.$t('DRIVER'), time: '22 days'}, {key: 'Supervisor', label: this.$t('SUPERVISOR'), time: '22 days'}, {key: 'Insurance', label: this.$t('INSURANCE'), time: '180 days'}, {key: 'Finance', label: this.$t('VECHICLEPAYMENTS'), time: '22 days'}, {key: 'Registration', label: this.$t('REGISTRATION'), time: '180 days'}, {key: 'Inspection', label: this.$t('INSPECTION'), time: '180 days'}, {key: 'Permit', label: this.$t('VEHICLEPERMIT'), time: '180 days'}, {key: 'Depreciation', label: this.$t('VEHICLEDEPRECIATION'), time: '365 days'}, {key: 'Fuel', label: this.$t('FUELCONSUMPTION'), time: ''}, {key: 'Oil', label: this.$t('OILCHANGE'), time: ''}, {key: 'Idling', label: this.$t('IDLING'), time: '60 mins'}, {key: 'Tire', label: this.$t('TIRES'), time: ''}, {key: 'Wear_Tear', label: this.$t('WEARTEAR'), time: ''}]
        for (let exp in this.expense) {
          for (let index in factors) {
            if (exp === factors[index].key) {
              factors[index].cost = this.expense[exp]
              if (factors[index].time.indexOf('days') < 0) {
                if (factors[index].key === 'Idling') {
                  factors[index].calc = this.expense[exp] + ' * ' + this.idlingTime + ' ' + 'mins'
                  factors[index].result = (this.expense[exp] * this.idlingTime).toFixed(3)
                } else {
                  factors[index].calc = this.expense[exp] + ' * ' + this.distance + ' ' + 'km'
                  factors[index].result = (this.expense[exp] * this.distance).toFixed(3)
                }
              } else {
                let doneTrips = this.expense['doneTrips'] < 2 ? 2 : this.expense['doneTrips']
                if (factors[index].key === 'Depreciation') {
                  factors[index].calc = '((' + this.expense['Price'] + ' * ' + (this.expense[exp] / 100) + ')' + ' / ' + factors[index].time + ') / ' + doneTrips + ' ' + this.$tc('TRIP', doneTrips < 2 ? 1 : 2)
                  factors[index].result = ((this.expense['Price'] * (this.expense[exp] / 100) / factors[index].time.split(' ')[0]) / doneTrips).toFixed(3)
                } else {
                  factors[index].calc = '(' + this.expense[exp] + ' / ' + factors[index].time + ') / ' + doneTrips + ' ' + this.$tc('TRIP', doneTrips < 2 ? 1 : 2)
                  factors[index].result = ((this.expense[exp] / factors[index].time.split(' ')[0]) / doneTrips).toFixed(3)
                }
              }
            }
          }
        }
        return factors
      }
    },
    methods: {
      subscribeToRFID () {
        if (this.trip.IsClosed === 1) return
        let id = this.trip.IMEI === null ? this.trip.TripID : this.trip.BusID
        this.$channel.bind('rfid-' + id, (data) => {
          this.trip.RFIDStatus = data
          for (let stop in this.stops) {
            stop = parseInt(stop)
            if (stop > 0) this.students_rfid(this.stops[stop].student)
          }
        })
      },
      subscribeToLocation () {
        if (this.trip.IsClosed === 1) return
        let id = this.trip.IMEI === null ? this.trip.TripID : this.trip.BusID
        this.$channel.bind('location-' + id, (data) => {
          this.trip.location = this.trip.location.concat(data)
          this.extendPath(data)
          this.setPulseLocation()
        })
      },
      showCost (trip) {
        if (trip.Db_Date != null && trip.IsClosed === 1 && trip.TotalCost > 0) return true
        return false
      },
      subscribeToBoarding () {
        if (this.trip.IsClosed === 1) return
        this.$channel.bind('boarding-' + this.trip.TripID, (data) => {
          EventBus.$emit('boarding', data)
          this.updateStudentStop(data)
        })
      },
      showMarker (stop) {
        if (stop === 0) return require('../../assets/img/map/school.png')
        return 'https://raw.githubusercontent.com/Concept211/Google-Maps-Markers/master/images/marker_green' + stop + '.png'
      },
      tripDate (date) {
        if (date === null) return this.$t('EXPECTEDTOSTART')
        return this.$moment(date).locale(localStorage.getItem('lang')).format('MMMM') + this.$moment(date).format(' DD, YYYY')
      },
      tripTime (time) {
        return this.$moment(time).format('hh:mm') + this.$moment(time).locale(localStorage.getItem('lang')).format(' A')
      },
      unixConverter (time) {
        return this.$moment.unix(time, 'hh:mm A').format('hh:mm') + this.$moment.unix(time, 'hh:mm A').locale(localStorage.getItem('lang')).format(' A')
      },
      updateStudentStop (boarding) {
        if (this.stops[boarding.Stop] === undefined) return
        let students = Object.assign({}, this.stops[boarding.Stop].student)
        for (let student in students) {
          if (students[student].StudentID === boarding.StudentID) {
            if (boarding.CheckIn !== undefined) this.$set(students[student], 'CheckIn', boarding.CheckIn)
            if (boarding.CheckOut !== undefined) this.$set(students[student], 'CheckOut', boarding.CheckOut)
            if (boarding.IsMissing !== undefined) this.$set(students[student], 'IsMissing', boarding.IsMissing)
            return
          }
        }
      },
      RFIDTagStatus (TagID) {
        if (this.trip.RFIDStatus === null || TagID === null) return false
        let RFIDStatus = this.trip.RFIDStatus
        TagID = this.base_convert(TagID, 10, 16)
        if (RFIDStatus.current !== undefined && RFIDStatus.current[TagID] !== null) return true
        return false
      },
      base_convert (number, initialBase, changeBase) {
        if ((initialBase && changeBase) < 2 || (initialBase && changeBase) > 36) return this.$t('BASEBETWEEN')
        return parseInt(number + '', initialBase).toString(changeBase)
      },
      getTrips () {
        let self = this
        let data = {filters: {}}
        data.filters.TripID = self.$route.params.id
        let trip = this.$http.get('/trip?' + qs.stringify(data))
        Promise.all([trip]).then(function (results) {
          self.loading = false
          self.trip = results[0].data.trips[Object.keys(results[0].data.trips)[0]]
          self.getRoute(self.trip)
        })
      },
      tagIcon (student) {
        if (student.rfid_status === null) return ''
        return student.rfid_status ? 'text-success' : 'text-danger'
      },
      getRoute (trip) {
        let self = this
        self.loading_stops = true
        this.subscribeToBoarding()
        this.subscribeToRFID()
        this.subscribeToLocation()
        let params = {TourID: trip.TourID, BusDriverID: trip.BusDriverID, BusMonitorID: trip.BusMonitorID, Direction: trip.Direction, Date: trip.Db_Date}
        this.$http.get('/trip/' + self.$route.params.id, {params: params}).then(function (response) {
          self.route = response.data.route
          self.stops = response.data.stops
          self.driver = response.data.driver
          self.monitor = response.data.monitor
          let duration = 0
          for (let stop in self.stops) {
            stop = parseInt(stop)
            self.idlingTime += self.stops[stop].WaitingTime
            if (stop > 0) {
              duration += self.stops[stop].DeltaT + self.stops[stop].WaitingTime
              self.stops[stop].DeltaT = duration
              self.students_rfid(self.stops[stop].student)
            }
          }
          for (let stop in self.stops) {
            self.stops[stop].Stop = parseInt(stop)
            self.addMarker(self.stops[stop])
          }
          self.drawPath()
          self.getPulseLocation()
          self.loading_stops = false
          self.mapHeight -= self.$refs.cost.$el.offsetHeight
        }).catch(function (response) {
          self.loading_stops = false
        })
      },
      students_rfid (students) {
        let rfidStatus = null
        for (let student in students) {
          let TagID = students[student].AssignedTagID
          if (TagID !== null) {
            let hex = this.base_convert(TagID, 10, 16)
            rfidStatus = false
            if (this.trip.RFIDStatus !== null) {
              if (this.trip.RFIDStatus.current[hex] !== undefined || this.trip.RFIDStatus.current[TagID]) {
                rfidStatus = true
              }
            }
          }
          this.$set(students[student], 'rfid_status', rfidStatus)
        }
      },
      getSummaries (param) {
        const { columns, data } = param
        const sums = []
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = this.$t('TOTALCOST')
            return
          }
          const values = data.map(item => Number(item[column.property]))
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr)
              if (!isNaN(value)) {
                return prev + curr
              } else {
                return prev
              }
            }, 0).toFixed(2) + ' ' + this.$t('AED')
          } else {
            sums[index] = 'N/A'
          }
        })

        return sums
      },
      getExpense () {
        if (!_.isEmpty(this.expense)) return
        let params = {TourID: this.trip.TourID, BusID: this.trip.BusID}
        let self = this
        this.$http.get('/trip/expense', {params: params}).then(function (response) {
          self.expense = response.data
        }).catch(function (response) {
        })
      },
      haversineGreatCircleDistance (latitudeFrom, longitudeFrom, latitudeTo, longitudeTo, earthRadius = 6371000) {
        let latFrom = this.deg2rad(latitudeFrom)
        let lonFrom = this.deg2rad(longitudeFrom)
        let latTo = this.deg2rad(latitudeTo)
        let lonTo = this.deg2rad(longitudeTo)
        let latDelta = latTo - latFrom
        let lonDelta = lonTo - lonFrom
        let angle = 2 * Math.asin(Math.sqrt(Math.pow(Math.sin(latDelta / 2), 2) +
                Math.cos(latFrom) * Math.cos(latTo) * Math.pow(Math.sin(lonDelta / 2), 2)))
        return angle * earthRadius
      },
      deg2rad (val) {
        return val * (Math.PI / 180)
      },
      pinSymbol (color) {
        return {
          path: 'M0-48c-9.8 0-15.7 7.8-17.7 17.4 0 15.5 17.7 30.6 17.7 30.6s17.7-15.4 17.7-30.6c0-9.6-7.9-17.4-17.7-17.4z',
          fillColor: color,
          fillOpacity: 1,
          strokeColor: color,
          labelOrigin: new this.maps.Point(0, -25)
        }
      },
      drawPath () {
        /* eslint new-cap: ["error", { "newIsCap": false }] */
        let polyline = new this.maps.Polyline({
          path: new this.maps.geometry.encoding.decodePath(this.route.Polyline),
          strokeColor: this.route.RouteColor,
          strokeOpacity: 0.6,
          strokeWeight: 5
        })
        polyline.setMap(this.map)
        let path = []
        for (let item in this.trip.location) {
          item = parseInt(item)
          let position = this.trip.location[item]
          path.push(new this.maps.LatLng(position.Lat, position.Lng))
          if (this.trip.location[item + 1] !== undefined) this.distance += this.haversineGreatCircleDistance(position.Lat, position.Lng, this.trip.location[item + 1].Lat, this.trip.location[item + 1].Lng)
        }
        this.distance = Math.round(this.distance) / 1000
        this.path = new this.maps.Polyline({
          path: path,
          map: this.map,
          strokeColor: 'blue',
          strokeOpacity: 0.6,
          strokeWeight: 5
        })
      },
      addMarker (position) {
        let label = position.Stop + ''
        let marker = new this.maps.Marker({
          draggable: true,
          raiseOnDrag: true,
          position: new this.maps.LatLng(position.Lat, position.Lng),
          icon: this.pinSymbol(this.route.RouteColor),
          label: {
            text: label,
            color: '#fff',
            fontSize: '16px'
          }
        })
        if (position.Stop === 0) {
          marker.setIcon(require('../../assets/img/map/school.png'))
          marker.setLabel(null)
        }
        marker.setMap(this.map)
      },
      getPulseLocation () {
        if (this.trip.IsClosed === 1) return
        this.pulse = new this.MarkerWithLabel({map: this.map})
        this.pulse.setIcon({path: this.maps.SymbolPath.CIRCLE})
        this.pulse.set('labelClass', 'pulse')
        this.pulse.set('labelAnchor', new this.maps.Point(15, 15))
        this.setPulseLocation()
      },
      extendPath (locations) {
        for (let location in locations) {
          this.path.getPath().push(new this.maps.LatLng(parseFloat(locations[location].Lat), parseFloat(locations[location].Lng)))
        }
      },
      setPulseLocation () {
        if (this.trip.location.length === 0) return this.pulse.setMap(null)
        let location = this.trip.location[this.trip.location.length - 1]
        let position = new this.maps.LatLng(parseFloat(location.Lat), parseFloat(location.Lng))
        this.pulse.setMap(this.map)
        this.pulse.setPosition(position)
        this.map.panTo(position)
      }
    }
  }
</script>

<style>
  body{overflow: hidden}
.stop_btn{ display: block;}
.stop_btn button{width:100%; display: block; border-radius: 0; padding:20px 0;}
  .scroll{height: auto; overflow-y: auto; position: relative; margin: 0; padding: 0}
.scrollbar {  width: 100%; background: none }
  .el-steps{padding-left:15px; padding-bottom: 15px; padding-top: 15px}
  .el-step__title {margin-left: 0px;width:100% !important;}
  .el-step__main{display:block !important; padding-left:40px !important;padding-right:15px !important;margin-top:-32px; padding-bottom:20px}
  .searchInput input{border-radius: 0; border-width: 0; border-top-width:1px}
  .only-bottom-border .el-input-group__prepend{border-radius: 0  !important; border-width: 0  !important;; border-bottom-width:1px  !important;}
  .only-bottom-border .el-select{width:120px  !important; border-right:1px solid  rgb(191, 203, 217); border-top:1px solid  rgb(191, 203, 217);}
  .stop_btn{display: none}
  .el-step__main:hover .stop_btn{display: block}
  .el-step__main:hover .stop_btn{display: block}
  .timing .el-date-editor{width:170px !important}
  .students .el-card__header {background: #4b4b4b;
    color: #fff;}
  .el-step__title .list{line-height:1.5 !important; font-weight:400}
  .el-table__footer-wrapper td{font-weight:600}
</style>



// WEBPACK FOOTER //
// TripManage.vue?a34c74ca